import _ from "lodash"
import i18n from "@/internationalisation"
import { GROWL_TYPE_DANGER, useGrowlStore } from "@/stores/growl.store"

// API error codes returned by the backend bundle-protection validator, mapped to the translation
// snippet shown to the user. The whole-assortment delete code and Shopware's generic RestrictDelete
// violation (single bundled-product delete, which has no custom code) are included too, so a single
// helper can be dropped into every relevant save/delete catch block.
const BUNDLE_PROTECTION_MESSAGE_KEYS: Record<string, string> = {
  EECOM_TEAMPORTAL__BUNDLED_PRODUCT_CONFIGURATION_REMOVE: "eecom-teamportal.sales-force.product-range.bundleProtection.configurationRemove",
  EECOM_TEAMPORTAL__BUNDLED_PRODUCT_DEACTIVATION_LOCKED: "eecom-teamportal.sales-force.product-range.bundleProtection.productDeactivationLocked",
  EECOM_TEAMPORTAL__BUNDLED_PRODUCT_CUSTOMIZATION_REMOVE_ALL: "eecom-teamportal.sales-force.product-range.editConfiguration.cannotRemoveAllInBundle",
  EECOM_TEAMPORTAL__BUNDLED_PRODUCT_CUSTOMIZATION_ADD: "eecom-teamportal.sales-force.product-range.editConfiguration.cannotAddInBundle",
  EECOM_TEAMPORTAL__BUNDLED_PRODUCT_VISIBILITY_LOCKED: "eecom-teamportal.sales-force.product-range.bundleProtection.visibilityLocked",
  EECOM_TEAMPORTAL__ASSORTMENT_WITH_BUNDLED_PRODUCT_DEACTIVATION_LOCKED: "eecom-teamportal.sales-force.product-range.bundleProtection.assortmentDeactivationLocked",
  EECOM_TEAMPORTAL__ASSORTMENT_WITH_BUNDLED_PRODUCT_DELETE: "eecom-teamportal.sales-force.product-range.cannotDeleteAssortmentInBundle",
  // Single bundled product delete raises Shopware's generic RestrictDelete violation (no custom code).
  FRAMEWORK__DELETE_RESTRICTED: "eecom-teamportal.sales-force.product-range.cannotDeleteInBundle",
}

// Shows a danger growl for every bundle-protection API error in the response (a single request can
// violate multiple rules, e.g. configuration-remove + customization-add) and returns true when at
// least one was matched, so the caller can stop treating the request as a success. The response can
// also repeat the same code, so messages are deduped. Returns false for any other error.
export function handleBundleProtectionError(error: any): boolean {
  const errors: any[] = _.get(error, "response.data.errors", []) || []
  const messageKeys = errors.map((err: any) => (err?.code ? BUNDLE_PROTECTION_MESSAGE_KEYS[err.code] : undefined)).filter((key: string | undefined): key is string => Boolean(key))
  const uniqueKeys = Array.from(new Set(messageKeys))
  if (uniqueKeys.length === 0) {
    return false
  }
  const t = i18n.global.t as (key: string) => string
  const growlStore = useGrowlStore()
  uniqueKeys.forEach((key: string) => {
    growlStore.open({
      type: GROWL_TYPE_DANGER,
      title: t("eecom-teamportal.error.errorCommonTitle"),
      content: t(key),
    })
  })
  return true
}
